import notificationStyle from "../../assets/scss/Notification.module.scss";


const Notification = () => {
    const notification_list = [
        {
            id: 1,
            bg:1,
            icon: "ri-time-line fs-5 mt-0",
            title: "Business Hours:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
        {
            id: 2,
            bg:2,
            icon: "ri-time-line fs-5 mt-0",
            title: "Holiday Hours:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
        {
            id: 3,
            bg:3,
            icon: "ri-phone-line fs-5 mt-0",
            title: "Phone:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
        {
            id: 4,
            bg:4,
            icon: "ri-mail-line fs-5 mt-0",
            title: "Email:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
         {
            id: 5,
            bg:1,
            icon: "ri-user-line fs-5 mt-0",
            title: "Sales Representative:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
        {
            id: 6,
            bg:2,
            icon: "ri-phone-line fs-5 mt-0",
            title: "call sales Representative:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
         {
            id: 7,
            bg:3,
            icon: "ri-mail-line fs-5 mt-0",
            title: "Email sales Representative:",
            value:'Mon-Sun 9 AM-6 PM PST'
        },
    ];
    return (
        <div className={notificationStyle.notification_menu}>
            <p className={notificationStyle.menu_title}>Contact Details</p>
            {notification_list?.map((data) => (
                <a
                    href="/"
                    key={data.id}
                    className={`${notificationStyle.notification} d-flex align-items-center text-decoration-none p-1`}
                >
                    <i className={data.icon}></i>
                    <p className="">{data.title} {data.value}</p>
                </a>
            ))}
        </div>
    );
};

export default Notification;

